import React from 'react'
import './waitingLoaders.css'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

const WaitingLoaders = (props) => {
    const curTheme = props.theme ? props.theme : { action: { theme: 'light' } }

    // Visibility control
    const isVisible = props.show !== undefined ? props.show : props.isOpen
    if (!isVisible) return null

    const {
        size = 100,
        borderWidth = 6,
        innerSize = 35,
        innerBorderWidth = 3,
        color = 'var(--themeColor)',
        innerColor = '#000000',
        style = {},
        position = 'relative', // 🟩 new prop: 'relative' | 'absolute' | 'fixed'
    } = props

    // Message: manual > redux
    const displayMessage = props.message ? props.message : props.reduxMessage

    const loaderStyle = {
        width: size + 'px',
        height: size + 'px',
        borderWidth: borderWidth + 'px',
        borderColor: color,
        ...style,
    }

    const innerStyle = {
        width: innerSize + 'px',
        height: innerSize + 'px',
        borderWidth: innerBorderWidth + 'px',
        borderColor: innerColor,
    }

    const themeName =
        curTheme && curTheme.action && curTheme.action.theme
            ? curTheme.action.theme
            : 'light'

    let wrapperClass = 'Wparent-Wloader'
    if (position === 'absolute') wrapperClass += ' absolute-center'
    if (position === 'fixed') wrapperClass += ' fixed-center'

    return (
        <div className={wrapperClass} data-theme={themeName}>
            {displayMessage && <h3>{displayMessage}</h3>}
            <div className="Pwaiting-Loader" style={loaderStyle}>
                <div className="Pwaiting-Loader-inner" style={innerStyle}></div>
            </div>
        </div>
    )
}

const mapStateToProps = function (state) {
    return {
        theme: state.theme,
        isOpen: state.wLoader && state.wLoader.isOpen,
        reduxMessage: state.wLoader && state.wLoader.message,
    }
}

export default withRouter(connect(mapStateToProps)(WaitingLoaders))
